import AxiosControl from "../components/axios/AxiosControl";
const Axios = AxiosControl();

export const getDocuments = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/document/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DOCUMENT_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const getDocument = (document) => async (dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/document/get/' + document, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DOCUMENT_GET_SUCCESS',
                payload: data.document
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const addDocument = (documentdata) => async (dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/document/create', documentdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'DOCUMENT_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const editDocument = (documentdata, idDocument) => async (dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/document/update/' + idDocument, documentdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'DOCUMENT_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_ERROR'
        })
    }
}

export const deleteDocument = (idDocument) => async (dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.delete('/api/document/delete/' + idDocument, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'DOCUMENT_DELETE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_ERROR'
        })
    }
}